import React from 'react';

import { Field, SelectField } from 'src/components/finalForm';

import { VERIFIER_TYPE_OPTIONS } from '../constants';
import { InboxFilterFieldProps, InboxFilterFormFields } from '../types';

export const InboxFilterVerifierTypeField: React.FC<InboxFilterFieldProps> = ({ disabled }) => (
  <Field
    fullWidth
    component={SelectField}
    options={VERIFIER_TYPE_OPTIONS}
    name={InboxFilterFormFields.verifierType}
    label="Verifier Type"
    disabled={disabled}
  />
);
